import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CompaniesService } from '../../component/companies/service/companies.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { animate, style, transition, trigger } from "@angular/animations";
import * as moment from 'moment-timezone';
import { CorporateService } from '../../component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../component/level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../component/service-areas/service-areas-service/service-areas.service';
import { HolidayService } from 'src/app/component/extras/holidays/service/holiday.service';
@Component({
  selector: 'app-third-party-companies-trip-assign-modal',
  templateUrl: './third-party-companies-trip-assign-modal.component.html',
  styleUrls: ['./third-party-companies-trip-assign-modal.component.css'],
  animations: [
    trigger("openCloseAssignSlideOut", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateX(100%)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 0, transform: "translateX(-100%%)" })
        )
      ])
    ])
  ]
})
export class ThirdPartyCompaniesTripAssignModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input('assignModalObj') trip: any;
  @Output() tripAssigned = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<any>();
  user;
  searchCompany;
  selectedCompany: any = null;
  companiesList = [];
  isSubmitted = false;
  preCorporate;
  preLevelOfServices = {};
  preSpaceTypes: any = {};
  preServiceAreas = {};
  isInfo = false;

  constructor(
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private companiesService: CompaniesService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getUser();
    this.makeCompulsoryCalls();
  }

  ngOnChanges(changes): void {
    if (changes.trip && changes.trip.currentValue) {
      if (changes.trip.currentValue.company)
        this.selectedCompany = changes.trip.currentValue.company;
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
        }
      });
  }

  getCorporateUserById() {
    return this.corporateService.getCorporateUserById(this.trip.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
  }

  getLevelOfService() {
    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypes() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypes(),
      this.getServiceAreas(),
      this.getCorporateUserById()
    ];

    forkJoin(requests).subscribe(
      async ([res1, res2, res3, res4]) => {
        if (res1) {
          this.preLevelOfServices = await res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.preSpaceTypes = await res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res3) {
          this.preServiceAreas = await res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res4) {
          this.preCorporate = res4;
        }
        this.getCompaniesList();
      },
      error => {
        sweetAlert('Error', error, 'warning', 'OK');
      }
    );
  }

  getCompaniesList() {
    this.companiesService
      .getFarmoutCompanies()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.companiesList = (data && data.length) ? data : null;
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onSelectCompany(company) {
    this.selectedCompany = company;
  }

  assignTripToFarmoutCompany(trip: any) {
    this.isSubmitted = true;
    if (!this.selectedCompany) {
      return;
    }

    this.companiesService
      .assignTripToFarmoutCompany(this.selectedCompany._id, trip._id, trip)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(() => {
        this.tripAssigned.emit('Trip Assigned');
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  closeModal() {
    this.onCloseModal.emit('close');
  }

  openCloseInfo() {
    this.isInfo = !this.isInfo;
  }

  ngOnDestroy(): void {
  }
}
